import { Button } from "antd";
import { useQuery } from "@tanstack/react-query";

import DrawTableTr from "./DrawTableTr";
import StatusValue from "../../atoms/StatusValue";
import DrawTableHead from "./DrawTableHead";
import { PiWarningBold } from "react-icons/pi";
import { useAppStore } from "../../../store/store";
import { QueryKeys } from "../../../enums/react-query";
import { getWithdrawal } from "../../../services/withdrawal/withdrawal.service";
import { currencyFormatter, handleWalletAddress } from "../../../utils/helper";
import { getDeposit } from "../../../services/deposit/deposit.service";
import { TDeposit, TWithdrawal } from "../../../types/types";
import classNames from "classnames";

const DashBoardDraw = () => {
  const drawerId = useAppStore((state) => state.drawerId);
  const setModalType = useAppStore((state) => state.setModalType);
  const setModalIsOpen = useAppStore((state) => state.setModalIsOpen);
  const setModalData = useAppStore((state) => state.setModalData);

  const { isLoading: isWithdrawalDataLoading, data: withdrawalData } = useQuery(
    {
      queryKey: [QueryKeys.GETWITHDRAWALDATA, drawerId],
      queryFn: async () => {
        const res = await getWithdrawal(drawerId);
        return res.data;
      },
    },
  );

  const { isLoading: isDepositDataLoading, data: depositData } = useQuery({
    queryKey: [QueryKeys.GETDEPOSITDATA, drawerId],
    queryFn: async () => {
      const res = await getDeposit(drawerId);
      return res.data;
    },
  });

  const handleReportWIthdrawal = () => {
    if (drawerData) {
      if (withdrawalData?.payload) {
        setModalType("reportWithdrawal");
      } else {
        setModalType("reportDeposit");
      }
      setModalIsOpen(true);
      setModalData([drawerData?._id]);
    }
  };

  const isLoading = isWithdrawalDataLoading || isDepositDataLoading;

  const payload = withdrawalData?.payload || depositData?.payload;

  const drawerData = payload as (TWithdrawal | TDeposit) | undefined;

  return (
    <div className="max-md:p-[15px] p-[30px] w-full">
      <h5 className="text-[16px] 2xl:text-[20px] font-[600] text-[#374151]">
        DETAILS
      </h5>

      <div className="mt-[30px]">
        <table className="w-full">
          <thead>
            <DrawTableHead
              title1={
                withdrawalData?.payload
                  ? "Withdrawal details"
                  : "Deposit Details"
              }
              title2={new Date(drawerData?.createdAt || "").toDateString()}
              isLoading={isLoading}
            />
          </thead>
          <tbody>
            <DrawTableTr
              title={"Amount withdrawn"}
              value={`${drawerData?.currency.symbol} ${currencyFormatter(drawerData?.amount, 2)}`}
              isLoading={isLoading}
            />
            <DrawTableTr
              title={"Currency"}
              value={
                <div className="flex items-center justify-end gap-1">
                  <img src={drawerData?.currency.flag} className="w-6 h-4" />{" "}
                  <span>{drawerData?.currency.name}</span>
                </div>
              }
              isLoading={isLoading}
            />
            <DrawTableTr
              title={"Status"}
              value={
                <StatusValue
                  value={drawerData?.status || ""}
                  className="ml-auto"
                />
              }
              isLoading={isLoading}
            />
          </tbody>
        </table>
      </div>

      <div
        className={classNames(
          { hidden: depositData?.payload },
          "mt-[45px] block",
        )}
      >
        <table className="w-full">
          <thead>
            <DrawTableHead
              title1="Account information"
              title2=""
              isLoading={isLoading}
            />
          </thead>
          {withdrawalData?.payload?.destinationAccount?.accountType ===
          "fiat" ? (
            <tbody>
              <DrawTableTr
                title={"Full name"}
                value={
                  withdrawalData?.payload?.destinationAccount?.accountData
                    ?.accName
                }
                isLoading={isLoading}
              />
              <DrawTableTr
                title={"Account Number"}
                value={
                  withdrawalData?.payload?.destinationAccount?.accountData
                    ?.accNumber
                }
                isLoading={isLoading}
              />
              <DrawTableTr
                title={"Bank"}
                value={
                  withdrawalData?.payload?.destinationAccount?.accountData?.bank
                }
                isLoading={isLoading}
              />
              <DrawTableTr
                title={"Country"}
                value={drawerData?.currency.country || ""}
                isLoading={isLoading}
              />
            </tbody>
          ) : (
            <tbody>
              <DrawTableTr
                title={"Chain"}
                value={
                  withdrawalData?.payload?.destinationAccount?.accountData
                    ?.chain || ""
                }
                isLoading={isLoading}
              />
              <DrawTableTr
                title={"Wallet Address"}
                value={
                  handleWalletAddress(
                    withdrawalData?.payload?.destinationAccount?.accountData
                      ?.publicKey,
                  ) || ""
                }
                isLoading={isLoading}
              />
              <DrawTableTr
                title={"Token Type"}
                value={(
                  withdrawalData?.payload?.destinationAccount?.accountType || ""
                ).toUpperCase()}
                isLoading={isLoading}
              />
            </tbody>
          )}
        </table>
      </div>

      <div className="mt-[30px] flex justify-end">
        <Button
          type="primary"
          className="rounded-[8px] h-[40px] !px-[16px] !py-[10px] flex items-center text-brand-darkYellow font-[500] text-[14px] 2xl:text-[16px] bg-[#FFF1DA] hover:!bg-[#FFF1DA] hover:!text-brand-darkYellow hover:opacity-[0.8] "
          icon={<PiWarningBold className="text-[20px] text-brand-darkYellow" />}
          onClick={handleReportWIthdrawal}
        >
          Report {withdrawalData?.payload ? "Withdrawal" : "Deposit"}
        </Button>
      </div>
    </div>
  );
};

export default DashBoardDraw;
